import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CookbookState {
  private currentPage: Record<string, number | undefined> = {};
  private maxPages: Record<string, number | undefined> = {};
  private recipeCount: Record<string, number | undefined> = {};
  private pageSize: number = 10;
  private reverse: boolean = false;
  private tab = new BehaviorSubject<string>('mine');
  tab$ = this.tab.asObservable();

  setCurrentPage(page: number, tab: string) {
    this.currentPage = { ...this.currentPage, [tab]: page };
  }

  getCurrentPage(tab: string): number {
    return this.currentPage[tab] ?? 1;
  }

  /**
   * @deprecated Use `setTabRecipeCount` instead
   * @param maxPages The maximum number of pages for a given tab
   * @param tab The tab to set the maximum number of pages for
   */
  setMaxPages(maxPages: number, tab: string) {
    this.maxPages[tab] = maxPages;
  }

  /**
   * @deprecated Use `getTabRecipeCount` instead
   * @param tab The tab to get the number of pages for
   * @returns The number of pages for that tab
   */
  getMaxPages(tab: string): number | undefined {
    return this.maxPages[tab];
  }

  /**
   * @param tab The tab to set the number of recipes for
   * @param recipes The number of recipes for that tab
   */
  setTabRecipeCount(tab: string, recipes: number) {
    this.recipeCount[tab] = recipes;
  }

  /**
   * @param tab The tab to get the number of recipes for
   * @returns The number of recipes for that tab
   */
  getTabRecipeCount(tab: string): number | undefined {
    return this.recipeCount[tab];
  }

  setTab(tab: string) {
    this.tab.next(tab);
  }

  setPageSize(size: number) {
    this.pageSize = size;
  }

  getPageSize() {
    return this.pageSize;
  }

  getReverse() {
    return this.reverse;
  }

  setReverse(reverse: boolean) {
    this.reverse = reverse;
  }

  clearMaxPages() {
    this.maxPages = { mine: undefined, favorites: undefined };
  }

  clearPageRecipeCount() {
    this.recipeCount = {};
  }

  clearCurrentPage() {
    this.currentPage = { mine: 1, favorites: 1 };
  }

  clearTab() {
    this.tab.next('mine');
  }

  clearCache() {
    this.clearMaxPages();
    this.clearPageRecipeCount();
    this.clearCurrentPage();
    this.clearTab();
    this.pageSize = 10;
    this.reverse = false;
  }
}
